import React, { useState } from 'react';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import avatar from '../assets/Logo.png';
import heroImage from '../assets/hero-img.png';
import { API_URL, secret_key } from '../components/Constants';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { BiExit } from 'react-icons/bi';

const Login = () => {
  // inside Login()
  const navigate = useNavigate();
  const [data, setData] = useState({ email: '', password: '' });
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => setData({ ...data, [e.target.id]: e.target.value });
  const removeError = () => setErrorMessage('');
  const toggleRememberMe = () => setRememberMe(!rememberMe);
  const toggleShowPassword = () => setShowPassword(!showPassword);

const handleLogin = async (e) => {
  e.preventDefault();
  if (isSubmitting) return;

  setIsSubmitting(true);
  setErrorMessage('');

  try {
    // ---------------------------------
    // 1️⃣ Send Login Request
    // ---------------------------------
    const response = await axios.post(
      `${API_URL}/signin`,
      {
        data: {
          email: data.email,
          password: data.password
        },
        readotp: {
          is_portal: 'true',
          otp: 'false'
        }
      },
      {
        headers: { 'Content-Type': 'application/json' },
        validateStatus: () => true
      }
    );

    const result = response.data;
    console.log("Login API response:", result);

    // ---------------------------------
    // 2️⃣ Invalid Credentials
    // ---------------------------------
    if (!result || parseInt(result.success) !== 1) {
      setErrorMessage(result?.message || 'Invalid phone number or password.');
      return;
    }

    // ---------------------------------
    // 3️⃣ Single Organization
    // ---------------------------------
    if (result.mode === 'single') {
      const encryptedToken = CryptoJS.AES.encrypt(
        result.token,
        secret_key
      ).toString();

      const encryptedUser = CryptoJS.AES.encrypt(
        JSON.stringify(result.userData),
        secret_key
      ).toString();

      localStorage.setItem('token', encryptedToken);
      localStorage.setItem('_userdata', encryptedUser);

      window.location.href = '/';
      return;
    }

    // ---------------------------------
    // 4️⃣ Multiple Organizations
    // ---------------------------------
    if (result.mode === 'multiple' && Array.isArray(result.companies)) {

      const { value: selected } = await Swal.fire({
        title: 'Select Organization',
        html: `
          <div id="org-container" style="display:flex;flex-direction:column;gap:12px;margin-top:15px;">
            ${result.companies.map(c => `
              <div 
                class="org-option"
                data-value="${c.user_id}|${c.company_id}"
                style="
                  border:1px solid #e5e7eb;
                  border-radius:12px;
                  padding:14px;
                  cursor:pointer;
                  transition:all 0.2s ease;
                  text-align:left;
                "
              >
                <div style="font-weight:600;font-size:15px;color:#111827;">
                  ${c.company_name}
                </div>
                <div style="font-size:13px;color:#6b7280;margin-top:4px;">
                  Parent: ${c.user_name}
                </div>
              </div>
            `).join('')}
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Continue',
        confirmButtonColor: '#2563eb',
        allowOutsideClick: false,
        didOpen: () => {
          const options = document.querySelectorAll('.org-option');

          options.forEach(option => {
            option.addEventListener('click', () => {
              options.forEach(o => {
                o.classList.remove('selected');
                o.style.borderColor = '#e5e7eb';
                o.style.backgroundColor = '#fff';
              });

              option.classList.add('selected');
              option.style.borderColor = '#2563eb';
              option.style.backgroundColor = '#eff6ff';
            });
          });
        },
        preConfirm: () => {
          const selectedOption = document.querySelector('.org-option.selected');

          if (!selectedOption) {
            Swal.showValidationMessage('Please select an organization');
            return false;
          }

          return selectedOption.getAttribute('data-value');
        }
      });

      if (!selected) return;

      const [user_id, company_id] = selected.split('|');

      // ---------------------------------
      // 5️⃣ Call Select Company Endpoint
      // ---------------------------------
      Swal.fire({
        title: 'Switching organization...',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      const selectResponse = await axios.post(
        `${API_URL}/select-company`,
        { user_id, company_id, },
        { headers: { 'Content-Type': 'application/json' } }
      );

      const selectResult = selectResponse.data;

      if (parseInt(selectResult.success) !== 1) {
        Swal.close();
        setErrorMessage(selectResult?.message || 'Invalid organization selection.');
        return;
      }

      const encryptedToken = CryptoJS.AES.encrypt(
        selectResult.token,
        secret_key
      ).toString();

    const encryptedUser = CryptoJS.AES.encrypt(
      JSON.stringify(selectResult.userData),
      secret_key
    ).toString();

    localStorage.setItem('token', encryptedToken);
    localStorage.setItem('_userdata', encryptedUser);

      window.location.href = '/';
      return;
    }

    // ---------------------------------
    // 6️⃣ Unexpected Response
    // ---------------------------------
    setErrorMessage('Unexpected authentication response.');

  } catch (error) {
    console.error('Login error:', error.response || error);
    setErrorMessage(
      error.response?.data?.message || 
      'Unable to connect to authentication server.'
    );
  } finally {
    setIsSubmitting(false);
  }
};


  return (
  <div
    style={{
      display: 'flex',
      minHeight: '100vh',
      fontFamily: 'Inter, sans-serif',
      background: '#f1f5f9',
      flexWrap: 'wrap',
    }}
  >
    {/* Form Section */}
    <div
      style={{
        flex: 1,
        minWidth: 360,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px 20px',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 420,
          backgroundColor: '#4e6b17',
          padding: '45px 35px',
          borderRadius: 20,
          boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
          textAlign: 'center',
          border: '3px solid #1dbbeb',
          animation: 'fadeIn 0.7s ease',
        }}
      >
        {/* Logo */}
        <img
          src={avatar}
          alt="Logo"
          style={{
            width: 110,
            height: 110,
            borderRadius: '50%',
            border: '3px solid #10b981',
            padding: 5,
            marginBottom: 20,
            backgroundColor: '#1bb2ee',
            boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
            objectFit: 'cover',
          }}
        />

        <h2
          style={{
            margin: 0,
            fontWeight: 800,
            color: '#e2fbe8',
            fontSize: '1.75rem',
          }}
        >
          NGUNA PORTAL
        </h2>
        <p
          style={{
            color: '#d1fae5',
            fontSize: '1rem',
            margin: '10px 0 25px',
          }}
        >
          Welcome back! Please log in to continue.
        </p>

        <form onSubmit={handleLogin}>
          {/* Phone Input */}
          <div style={{ position: 'relative', marginBottom: 20 }}>
            <i
              className="fas fa-phone"
              style={{
                position: 'absolute',
                left: 14,
                top: '50%',
                transform: 'translateY(-50%)',
                fontSize: '17px',       // ⬅ sharp on mobile
                color: '#1f8d31',
                textShadow: '0 0 2px rgba(0,0,0,0.25)',

                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
              }}
            />

            <input
              type="text"
              id="email"
              placeholder="Phone number"
              onChange={handleChange}
              onFocus={removeError}
              required
              style={{
                width: '100%',
                padding: '12px 12px 12px 42px',
                borderRadius: 10,
                backgroundColor: '#ffffff1a',
                color: '#e8ffe8',
                border: '1px solid #c8e6c9',
                fontSize: 15,
                backdropFilter: 'blur(4px)',
              }}
            />
          </div>

          {/* Password */}
          <div style={{ position: 'relative', marginBottom: 20 }}>
<i
  className="fas fa-lock"
  style={{
    position: 'absolute',
    left: 14,
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '18px',
    color: '#10b981',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  }}
/>


            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              placeholder="Password"
              onChange={handleChange}
              onFocus={removeError}
              required
              style={{
                width: '100%',
                padding: '12px 12px 12px 42px',
                fontSize: 15,
                borderRadius: 10,
                backgroundColor: '#ffffff26',
                color: '#e8ffe8',
                border: '1px solid #c8e6c9',
              }}
            />
            <i
              className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
              onClick={toggleShowPassword}
              style={{
                position: 'absolute',
                right: 14,
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#1adada',
              }}
            />
          </div>

          {/* Remember / Forgot */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 25,
              color: '#e2fbe8',
              fontSize: 14,
            }}
          >
            <label style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={toggleRememberMe}
                style={{ marginRight: 6 }}
              />
              Remember Me
            </label>
            <a
              href="password_reset"
              style={{ textDecoration: 'none', color: '#bbf7d0' }}
            >
              Forgot password?
            </a>
          </div>

          {/* Login Button */}
          <button
            type="submit"
            disabled={isSubmitting}
            style={{
              width: '100%',
              padding: 13,
              backgroundColor: '#28b7d9',
              borderRadius: 10,
              border: 'none',
              color: '#fff',
              fontWeight: 600,
              fontSize: 16,
              cursor: 'pointer',
              transition: '0.3s',
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = '#0ea5e9')
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = '#28b7d9')
            }
          >
            {isSubmitting ? 'Logging in...' : 'Login'}
          </button>

          {errorMessage && (
            <div
              style={{
                marginTop: 20,
                padding: 12,
                borderRadius: 8,
                color: '#ef4444',
                backgroundColor: '#fef2f2',
                border: '1px solid #fecaca',
                fontSize: 14,
              }}
            >
              {errorMessage}
            </div>
          )}
        </form>
      </div>
    </div>

{/* Right Image Section */}
<div
  style={{
    flex: 1,
    minWidth: 360,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #10b981, #4e6b17)',
    padding: 25,
  }}
>
  <img
    src={heroImage}
    alt="Portal Illustration"
    style={{
      width: '100%',
      maxWidth: 700,
      borderRadius: 24, // slightly smoother corners
      objectFit: 'cover',
      boxShadow: '0 20px 40px rgba(0,0,0,0.25)', // deeper shadow for elegance
      border: '4px solid rgba(173, 216, 230, 0.5)', // light-blue semi-transparent outline
      transition: 'transform 0.5s ease, box-shadow 0.5s ease, border-color 0.5s ease',
    }}
    onMouseOver={(e) => {
      e.currentTarget.style.transform = 'scale(1.05)';
      e.currentTarget.style.boxShadow = '0 25px 50px rgba(0,0,0,0.35)';
      e.currentTarget.style.borderColor = 'rgba(173, 216, 230, 0.9)'; // intensify outline
    }}
    onMouseOut={(e) => {
      e.currentTarget.style.transform = 'scale(1)';
      e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.25)';
      e.currentTarget.style.borderColor = 'rgba(173, 216, 230, 0.5)';
    }}
  />
</div>

  </div>
);
};

export default Login;
